module.exports = "/remote-dist/5778fd77bc3d6b38d6cec7a16ed68dee.png";